import axiosInstance from "app/axios";
import { AxiosResponse } from "axios";
import { CertificateTypeInterface } from "interfaces/CertificateType";
import { UserRoles } from "interfaces/UserRoles";

export interface patchSellerInterface {
  taxation_kind_id?: string;
  certificates?: CertificateTypeInterface[];
  id: string;
  endpoint?: UserRoles
}

export interface PostSellerResponseInterface {
  data: {
    errors: {
      [key: string]: {
        [key: string]: {
          [key: string]: string[];
        }
      }
    }
  };
}

export function updateSeller({ taxation_kind_id, certificates, id, endpoint = UserRoles.Admin }: patchSellerInterface): Promise<AxiosResponse<PostSellerResponseInterface, any>> {
  return axiosInstance.patch(`${endpoint}/sellers/${id}`, {
    taxation_kind_id,
    certificates_attributes: certificates
  });
}